import { UserManager, WebStorageStateStore } from 'oidc-client';
import { setAuth } from '../redux/authSlice'
import { setAuthHeader } from '../utils/axiosHeader'
import { removeLocalStorage } from '../redux/browser-storage';
import { useSelector, useDispatch } from 'react-redux';

const baseUrl = window.location.origin;

export function createUserManager() {
    return new UserManager({
        authority: window.authenticationConfig.authority,
        client_id: window.authenticationConfig.clientId,
        response_type: window.authenticationConfig.responseType,
        scope: window.authenticationConfig.scope,
        redirect_uri: `${baseUrl}/signin`,
        post_logout_redirect_uri: `${baseUrl}/signout`,
        userStore: new WebStorageStateStore({ store: window.localStorage })
    });
}

export async function loadUserFromStorage(store, userManager) {
    try {
        if (!userManager){
            store.dispatch(setAuth({user: null}));
            removeLocalStorage()
            return null;
        }

        const user = await userManager.getUser();
        if (!user){
            store.dispatch(setAuth({user: null}));
            removeLocalStorage();
            return null;
        }

        setAuthHeader(user.access_token);
        store.dispatch(setAuth({user: user}));
        return user;
    } catch (e) {
        console.error(`User not found: ${e}`);
        store.dispatch(setAuth({user: null}));
        removeLocalStorage();
        return null;
    }
}

export function signinRedirect(userManager) {
    return userManager.signinRedirect();
}

export function signinRedirectCallback(userManager) {
    return userManager.signinRedirectCallback();
}

export async function signoutRedirect(userManager) {
    const user = await userManager.getUser();
    userManager.clearStaleState();
    userManager.removeUser();
    return userManager.signoutRedirect({id_token_hint: user.id_token});
}

export function signoutRedirectCallback(userManager) {
    userManager.clearStaleState();
    userManager.removeUser();
    return userManager.signoutRedirectCallback();
}
